import { format, formatRFC3339 } from 'date-fns'

export function parseDateString(d: Date): DateString {
  return format(d, 'yyyy-MM-dd') as DateString
}

export function parseTimeString(d: Date): TimeString {
  return d.toISOString() as TimeString
}

export function fromTimeString(t: TimeString): Date {
  return new Date(t)
}

export function fromTimeStringToDate(t: DateString): Date {
  return new Date(t)
}

export function toTimeString(t: Date): TimeString {
  return formatRFC3339(t) as TimeString
}
